import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface LastUpdatedResponse {
  LastUpdated: string;
}

export const useReportLastUpdatedQuery = () => {
  return useQuery<LastUpdatedResponse>({
    queryKey: ["reportLastUpdated"],
    queryFn: async () => {
      const { data } = await axios.get<LastUpdatedResponse>("/api/reports/v1/system/last-updated");
      return data;
    },
  });
};
